import { memo } from 'react';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';

import ProjectInfo from 'shared/ProjectInfo';
import IconButton from 'shared/IconButton';

import { DEFAULT_BORDER_RADIUS } from 'constants/global';

const ProjectModal = ({ isOpen, onClose, ...props }) => (
  <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
    <ModalOverlay bgColor="rgba(0,0,0,0.8)" />
    <ModalContent
      w={{
        mobile: 'calc(100% - 16px)',
        tablet: 'calc(100% - 90px)',
        laptop: 'calc(100% - 174px)',
      }}
      maxW={{ mobile: '360px', tablet: '652px', laptop: '1264px' }}
      maxH="calc(100% - 6.5rem)"
      p={{
        mobile: '8px 4px 16px 8px',
        tablet: '20px 16px 20px 20px',
        laptop: '24px 20px 32px 24px',
      }}
      mt={{ mobile: '76px', tablet: '80px' }}
      mr={{ mobile: '8px', tablet: '72px', laptop: '135px' }}
      ml={{ mobile: '8px', tablet: '18px', laptop: '39px' }}
      borderRadius={DEFAULT_BORDER_RADIUS}
      bgColor="white"
    >
      {/* @ts-ignore */}
      <ProjectInfo {...props} />

      <IconButton
        direction="cross"
        bgColor="bg.white"
        ml="auto"
        pos="absolute"
        top={{ mobile: '-56px', tablet: '0px' }}
        right={{ mobile: '0px', tablet: '-56px', laptop: '-96px' }}
        border="none"
        boxSize={{ laptop: '72px', mobile: '40px' }}
        iconProps={{ boxSize: { laptop: '32px', mobile: '20px' } }}
        onClick={onClose}
      />
    </ModalContent>
  </Modal>
);

export default memo(ProjectModal);
